/* global define, SU */
define('componentDealerDetail',[
  'jquery',
  'Maps',
  'lib/util/tda.config',
  'lib/tda/kac',
  'responsive',
  'cookies',
  'lib/util/langFromUrl',
  'lib/getParameterByName',
  'bxStrip',
  'modernizr',
  'dealerLiveChat',
  'features/ctas/index',

  // side effect includes
  'lib/helpers/offer-bundle' // used by template-offercards & template-offermodal
], function (
  $,
  buildMap,
  tdaConfig,
  kac,
  responsive,
  cookies,
  langFromUrl,
  getParameterByName,
  BxStrip,
  modernizr,
  dealerLiveChat,
  ctas
) {
  var MOVE_SLIDES_DESKTOP = 3;

  var dealerDetail = {
    $el: $('#dealer-detail'),
    service: '/BATWS/tooms/search/offers',
    serviceParams: {
      dealerCode: ''
    },

    init: function () {
      var self = this;
      buildMap()
        .then(function (MapsConstructor) {
          self.drawMap(MapsConstructor);
        })
        .catch(function (err) { console.log('err in maps: ', err); });
      /*------------------------------------------------------------------
      Timing issue in production where TOOMS and displayContactAtOnceCta
      were failing, because this.serviceParams.dealerCode was undefined.
      populate it on init instead
      --------------------------------------------------------------------*/
      this.serviceParams.dealerCode = $('#dealer-detail').attr('data-dealercode');
      this.setupAwards();
      this.dealerData();
      this.getTOOMS();
      this.displayContactAtOnceCta();
      this.customCTAs();
      this.handleDeepLink();
      ctas.compare(undefined, undefined, self.$el);

      // Update phone # and tel link in the all numbers table, using default phone from DOM
      var $dealerPhone = $('.dealer-phone-main');
      var dealerPhoneNum = $dealerPhone.data('phone');
      var dealerPhoneLink = $dealerPhone.children('a').attr('href');
      $('.js-all-phone').attr('href', dealerPhoneLink).text(dealerPhoneNum);

      $('.phone-number-new').each(function (idx, item) {
        var txt = $(item).text();
        var fmt = window.bat.formatPhoneLink(txt);
        var telLink = ('tel:' + fmt);
        $(item).attr('href', telLink);
      });

      // TODO: update days of week with spanish text on /es/ ?

      if ($('.certification-indicator div').length > 0) {
        $('.certification-item').removeClass('hidden');
        // $('.certification-bullet').removeClass('hidden');
      }

      if ($('.language-bullet').length > 0) {
        $('.language-item').removeClass('hidden');
      }

      var isSafari = $('html').hasClass('safari');
      var isMac = $('html').hasClass('mac');
      var isFF = $('html').hasClass('firefox');

      $('.js-maps').each(function () {
        var address = $('.detail-more-address p a').html().replace(',', '');// example: "1605 VFW ParkwayBoston, MA 02132"
        var urlfa = address.replace(/ /g, '+');
        var mapurl = 'https://maps.google.com/?daddr=' + urlfa;
        // if this is safari or Mac Firefox, let's use apple maps. (Chrome on mac does not handle maps.apple links nicely)
        if (isSafari || (isMac && isFF)) {
          mapurl = 'https://maps.apple.com/?daddr=' + urlfa;
        }
        // console.log(mapurl);
        $(this).attr('href', mapurl);
      });

      window.bat.util.loader.hideLoader();
    }, // END init

    drawMap: function (MapsConstructor) {
      var draggable = true;
      if (responsive() === 'sm') {
        draggable = false;
      }
      var detailMap = new MapsConstructor({
        kind: 'direction',
        $form: $('.m-direction-form'),
        mapOptions: {
          zoom: 17,
          backgroundColor: '#ccc',
          draggable: draggable
        },
        mapElement: document.getElementById('map-canvas')
      });
    },

    displayContactAtOnceCta: function () {
      // KAC does NOT use contact at Once
      if (tdaConfig.tda.code !== 'KAC10') {
        var providerId = $('#defaultzipcode').attr('providerid');
        if (providerId === '') {
        // console.log('setting providerId by url parameter');
          providerId = getParameterByName('dealercode');
        }
        var merchantId = this.serviceParams.dealerCode; // 'merchantId'

        // feature-GNY-241-contact-at-once - Show Contact At Once info only if dealer is online
        // TODO: Do we still need this, since they can still chat even if dealer is NOT online?
        var promisedContactAtOnceStatus = window.bat.dealerChatPresence(providerId, merchantId, 'dealerdetailchat');
        $.when(promisedContactAtOnceStatus).then(
          // done
          function (response) {
            if (response.isOnline) {
              var $clickToChatCta = $("a[data-destination='live-chat']");
              $clickToChatCta.fadeIn(); // hidden by default via inline CSS - dealer-detail_default-skin.xsl
              $clickToChatCta.on('click', function () {
                var chatUrl = 'http://buyatoyota.contactatonce.com/caoclientcontainer.aspx?ProviderId=' + providerId + '&MerchantId=' + merchantId + '&PlacementId=1&OriginationUrl=' + encodeURIComponent(location.href);
                window.open(chatUrl, 'CAO', 'resizable=yes,toolbar=no,menubar=no,location=no,scrollbars=no,status=no,height=400,width=600');
              });
              $.getScript('//toyota.contactatonce.com/scripts/PopIn.js');
              $.getScript('//toyota.contactatonce.com/PopInGenerator.aspx?MerchantId=' + merchantId + '&ProviderId=' + providerId + '&PlacementId=1', function () {
                // console.group('COA dealer-detail.js, getScript has completed');
                // console.groupEnd();
                function wrappedPopin() {
                  try {
                    popIn();
                  } catch (Exception) {
                    // console.log('Error on the popIn:', Exception);
                  }
                }
                wrappedPopin();
              });
            }
          },
          // fail
          function (status) {
            // console.group('COA dealer-detail.js, in promise OBJ rejected');
            // 	console.log('CAO promise rejected status: ', status);
            // console.groupEnd();
          },
          // progress
          function (status) {
            // console.group('COA dealer-detail.js, in promise OBJ progress');
            // 	console.log('CAO promise progress: ', status);
            // console.groupEnd();
          }
        );
      }
    },

    customCTAs: function () {
      // Add custom CTA link logic here
      $("a[data-destination='custom']").each(function (i, customCTALink) {
        var $this = $(this);
        var customUrl = $this.attr('href');
        // console.log("customUrl: " + customUrl);
        var customUrlArr = customUrl.split('/'); // split it into an array, so we can drop the unused parts
        if (customUrlArr[1] == 'sites') {
          customUrlArr.splice(0, 3); // Drop the first 3 items from array ('', 'sites', 'TDA')
          customUrlArr.unshift('/' + tdaConfig.site.context_url);
        }

        var finalUrl = customUrlArr.join('/'); // create URL from array
        // console.log("finalUrl: " + finalUrl);
        $this.attr('href', finalUrl);
      });

      var $clickToChatCta = $("a[data-destination='live-chat']");
      var providerId = tdaConfig.chat.provider_id;
      if (($clickToChatCta.length > 0) && (providerId !== '')) {
        // $clickToChatCta.show();
        if (tdaConfig.tda.code === 'KAC10') {
          $clickToChatCta.addClass('etsChatButton');
          $clickToChatCta.attr('data-destination', 'live-chat-kac');
          kac.dealerChat(); // BAT-2915 KAC only Chat w/Dealer CTAs
        } else {
          dealerLiveChat.init(providerId);
        }
      }
    },

    getTOOMS: function () {
      var self = this;
      $.getJSON(self.service, self.serviceParams).done(function (data) {
        self.resp = data.results;
        self.insertData();
        // console.info('TOOMS DATA:', data);
      });
    }, // END getTOOMS

    insertData: function () {
      var dataArray = [];
      // If there are results, proceed
      if (this.resp) {
        if (this.resp.offerDTOs) {
          for (var x = 0; x < this.resp.totalOffersFound; x++) {
            dataArray = dataArray.concat(this.resp.offerDTOs[x]);
          }
        }

        $.each(dataArray, function (index, value) {
          if (value.offerDetailsImagePath.indexOf('.pdf') > 0) {
            value.offerImageType = 'pdf';
          }
        });
      }

      var offerCardTemplate = $('#template-offercards').html();
      var offerCardHandlebar = Handlebars.hcompile(offerCardTemplate, {
        data: dataArray
      });
      var offerModalTemplate = $('#template-offermodal').html();
      var offerModalHandlebar = Handlebars.hcompile(offerModalTemplate, {
        data: dataArray
      });

      $('.data-toomscards').html(offerCardHandlebar);
      $('body').append(offerModalHandlebar);

      if (dataArray.length > 0) {
        // TODO: test this
        // if (data.results.totalOffersFound > 0){
        //  $('#section-details-offers').show();
        // }
        $('#section-details-offers').show();
      }

      this.initCard();
    }, // END insertData

    initCard: function () {
      var $component = $('#tooms-slider');
      if ($component.find('.card').length > 2) {
        var isTouch = modernizr.touch;
        var strip = new BxStrip({
          '$component': $('#tooms-slider'),
          '$slider': $component.find('.offer-cards-slider'),
          bxoptions: {
            desktop: {
              waitForImageLoad: false,
              slideWidth: 100000,
              minSlides: 3.5,
              maxSlides: 3.5,
              moveSlides: MOVE_SLIDES_DESKTOP,
              infiniteLoop: false,
              slideMargin: 10,
              onSlideBefore: function () {
                setShadow();
              },
              onSliderLoad: function () {
                var $boxPagerItem = $component.find('.bx-pager-link');
                $boxPagerItem.off().on('click', function () {
                  if (isTouch) {
                    return false;
                  }
                });
              }
            },
            tablet: {
              waitForImageLoad: false,
              slideWidth: 100000,
              minSlides: 3,
              maxSlides: 3,
              infiniteLoop: false,
              slideMargin: 10,
              onSliderLoad: function () {
                var $boxPagerItem = $component.find('.bx-pager-link');
                $boxPagerItem.off().on('click', function () {
                  if (isTouch) {
                    return false;
                  }
                });
              }
            },
            phone: {
              waitForImageLoad: false,
              slideWidth: 100000,
              minSlides: 1.5,
              maxSlides: 1.5,
              moveSlides: 1,
              infiniteLoop: false,
              slideMargin: 10,
              onSlideBefore: function () {
                setShadow();
              },
              onSliderLoad: function () {
                var $boxPagerItem = $component.find('.bx-pager-link');
                $boxPagerItem.off().on('click', function () {
                  if (isTouch) {
                    return false;
                  }
                });
              }
            }
          }
        });
        // store service carousel, so we can reload it later
        dealerDetail.currentServiceCarousel = strip.slider;
      } else {
        // var url = document.location.toString();
        // if (!url.match('#')) {
        // this.filterByTab('#general-info');
        // }
        dealerDetail.currentServiceCarousel = '';
      }

      function setShadow() {
        var currentSlide = (strip.slider.getCurrentSlide() + 1) * MOVE_SLIDES_DESKTOP;

        if (currentSlide >= strip.slider.getSlideCount()) {
          $component.addClass('left-shadow');
        } else {
          $component.removeClass('left-shadow');
        }
      }
    },

    setupAwards: function () {
      // Show or hide the awards
      var $certBullets = $('#certification-bullets');

      if ($certBullets.find('.cab-award').length) {
        $('.CAB').show();
      }

      if ($certBullets.find('.bog-award').length) {
        $('.BOG').show();
      }

      if ($certBullets.find('.pa-award').length) {
        $('.presidents-award').show();
      }

      // to show or hide the awards based on language
      if (langFromUrl() === 'en') {
        $('.certification-bullet.es-data').hide();
      } else {
        $('.certification-bullet.en-data').hide();
      }
    },

    // Not yet used
    dealerData: function () {
      var dealerCode = $('#dealer-detail').attr('data-dealercode');
      $.ajax({
        dataType: 'json',
        url: '/BATWS/geo/rest/filterMode/getDealerDetails',
        data: {
          dealerCode: dealerCode,
          begin: 1,
          end: 1
        },
        beforeSend: function (xhrObj) {
          xhrObj.setRequestHeader('Content-Type', 'application/json');
          xhrObj.setRequestHeader('Accept', 'application/json');
          xhrObj.overrideMimeType('application/json');
        }
      }).done(function (data) {
        // console.group('dealerDetail.dealerData');
        // console.log(data);
        var is_mirai = dealerDetail.isDealerLocatorResultMirai(data.dealerLocator[0]);
        if (is_mirai) {
          $('.mirai-logo').show();
        }
        // console.log('full dealerDetail data: ', data.dealerLocator[0]);
        // dealerDetail.paintAllHoursTable(data.dealerLocator[0].dealerLocatorDetail.hoursOfOperation);
        dealerDetail.paintAllHoursTableCondensed(data.dealerLocator[0].dealerLocatorDetail.hoursOfOperation);
        // console.groupEnd();
      }).fail(function (jqXHR, textStatus, errorThrown) {
        // console.log('ERROR');
        // console.log(textStatus, errorThrown);
      });
    },

    dealerTimeConvert: function (dealerMinutes) {
      if (!dealerMinutes) {
        return '-';
      }
      var hour = Math.floor(dealerMinutes / 60);
      var remainder = dealerMinutes % 60;
      var colon = ':';
      if (remainder === 0) {
        colon = '';
        remainder = '';
      }

      var dayMode = hour < 12 ? 'AM' : 'PM'; // if it's less than 12 then "AM"
      var hours12 = hour <= 12 ? (hour == 0 ? 12 : hour) : hour - 12;
      return hours12 + colon + remainder + dayMode;
    },

    paintAllHoursTableCondensed: function (hoursData) {
      // get only General, Sales, Service data
      var deptsToGet = ['general', 'sales', 'service'];
      var deptsTemp = [];
      // for each department
      for (var i = 0; i < hoursData.length; i++) {
        var currDept = hoursData[i].hoursTypeCode.toLowerCase();
        if (deptsToGet.indexOf(currDept) > -1) {
          // deptsTemp.push(hoursData[i]);
          // for mon - sat push start minutes into array
          var tmp = [];
          var prevDayHourOpen = hoursData[i].daysOfWeek[0].availabilityStartTimeMeasure.value;
          var prevDayHourClose = hoursData[i].daysOfWeek[0].availabilityEndTimeMeasure.value;
          var prevDayCode = hoursData[i].daysOfWeek[0].dayOfWeekCode;
          var usedDays = [];
          var usedDaysIndex = [];
          var nextDays = [];
          var daysOutput;
          // console.log('Very first prevDayHour: ' + prevDayHourOpen);
          for (var j = 0; j < 6; j++) {
            var curHourOpen = hoursData[i].daysOfWeek[j].availabilityStartTimeMeasure.value;
            var curHourClose = hoursData[i].daysOfWeek[j].availabilityEndTimeMeasure.value;
            var curDayCode = hoursData[i].daysOfWeek[j].dayOfWeekCode;
            usedDays.push(curDayCode);
            usedDaysIndex.push(j);

            // we found a day that does not match
            if (curHourOpen !== prevDayHourOpen || curHourClose !== prevDayHourClose) {
              // drop the last day, and work with all the previous days
              usedDays.pop();
              nextDays.push(curDayCode);
              /* var hourOpen = dealerDetail.dealerTimeConvert(hoursData[i].daysOfWeek[0].availabilityStartTimeMeasure.value); // Always Monday
              var hourClose = dealerDetail.dealerTimeConvert(hoursData[i].daysOfWeek[0].availabilityEndTimeMeasure.value); // Always Monday */

              var usedDay1 = usedDays[0];
              var usedDay2 = usedDays[usedDays.length - 1];
              if (usedDay1.toLowerCase() === usedDay2.toLowerCase()) {
                daysOutput = usedDay1;
              } else {
                daysOutput = usedDay1 + ' - ' + usedDay2;
              }

              $('#js-hours-' + currDept).append('<tr><td>' + daysOutput + '</td><td>' + dealerDetail.dealerTimeConvert(prevDayHourOpen) + ' - ' + dealerDetail.dealerTimeConvert(prevDayHourClose) + '</td></tr>');

              usedDays = []; // now empty usedDays
              usedDaysIndex = [];
              usedDays.push(curDayCode);
              usedDaysIndex.push(j);
              // $('#js-hours-' + currDept).append('<tr><td>' + hoursData[i].daysOfWeek[j].dayOfWeekCode + '</td><td>' + hourOpen + ' - ' + hourClose + '</td></tr>');
            }
            prevDayHourOpen = curHourOpen;
            prevDayHourClose = curHourClose;
            // console.log('new PrevDayHour: ' + prevDayHourOpen);
            // tmp.push(hoursData[i].daysOfWeek[j].availabilityStartTimeMeasure.value);
          }
          // console.log('usedDays: ', usedDays)
          // console.log('usedDaysIndex: ', usedDaysIndex)
          // console.log('nextDays: ', nextDays)
          // console.log('tmp: ', tmp);
          var indexToUse = usedDaysIndex[0]; // grab the first item from our index store
          var currOpen = dealerDetail.dealerTimeConvert(hoursData[i].daysOfWeek[indexToUse].availabilityStartTimeMeasure.value);
          var currEnd = dealerDetail.dealerTimeConvert(hoursData[i].daysOfWeek[indexToUse].availabilityEndTimeMeasure.value);
          // prevent "Saturday - Saturday" from appearing

          var day1 = usedDays[0];
          var day2 = usedDays[usedDays.length - 1];
          if (day1.toLowerCase() === day2.toLowerCase()) {
            daysOutput = day1;
          } else {
            daysOutput = day1 + ' - ' + day2;
          }
          $('#js-hours-' + currDept).append('<tr><td>' + daysOutput + '</td><td>' + currOpen + ' - ' + currEnd + '</td></tr>');

          // Sundays:
          var sunOpen = hoursData[i].daysOfWeek[6].availabilityStartTimeMeasure;
          var sunEnd = hoursData[i].daysOfWeek[6].availabilityEndTimeMeasure;
          var sundayHours;
          if (sunOpen == null) {
            sundayHours = '-';
          } else {
            sundayHours = dealerDetail.dealerTimeConvert(sunOpen.value) + ' - ' + dealerDetail.dealerTimeConvert(sunEnd.value);
          }
          $('#js-hours-' + currDept).append('<tr><td>Sunday</td><td>' + sundayHours + '</td></tr>');
        }
      }
    },

    isDealerLocatorResultMirai: function (dealerLocatorResult) {
      var programGrepResults = [];
      var program;
      var isMirai;

      if (dealerLocatorResult && dealerLocatorResult.dealerMetaDataDetail && dealerLocatorResult.dealerMetaDataDetail.additionalService) {
        programGrepResults = $.grep(dealerLocatorResult.dealerMetaDataDetail.additionalService, function (element, index) {
          // return the additionalService with code TDA
          if (element.code) return element.code.value == 'MiraiSales';
        });

        if (programGrepResults.length) {
          program = programGrepResults[0];

          isMirai = program.participationIndicator;
        }
        // console.log('isMirai: ', isMirai);
      }

      if (window.location.pathname.indexOf('dealer-directory') != -1) {
        $('#search-more-dealers').hide();
        return true;
      } else {
        return isMirai;
      }
    },

    paintAllHoursTable: function (hoursData) {
      // get only General, Sales, Service data
      var deptsToGet = ['general', 'sales', 'service'];
      var deptsTemp = [];
      // for each department
      for (var i = 0; i < hoursData.length; i++) {
        var currDept = hoursData[i].hoursTypeCode.toLowerCase();
        // console.log(currDept)
        if (deptsToGet.indexOf(currDept) > -1) {
          // for each day of the week, output hours
          var dayArr = hoursData[i].daysOfWeek;
          for (var j = 0; j < dayArr.length; j++) {
            var currDay = dayArr[j].dayOfWeekCode;
            var currDayStart = dayArr[j].availabilityStartTimeMeasure;
            var currDayEnd = dayArr[j].availabilityEndTimeMeasure;
            if (currDayStart == null) {
              currDayHours = '-';
            } else {
              currDayHours = dealerDetail.dealerTimeConvert(currDayStart.value) + ' - ' + dealerDetail.dealerTimeConvert(currDayEnd.value);
            }
            $('#js-hours-' + currDept).append('<tr><td>' + currDay + '</td><td>' + currDayHours + '</td></tr>');
          }
        }
      }

      // console.log(deptsTemp);

      // console.log(dealerDetail.dealerTimeConvert(1200));

      // $('#js-hours-general').append('<tr><td>Monday - Saturday</td><td></td></tr>');
    },

    handleDeepLink: function () {
      var deepLinkParam = getParameterByName('deep');
      var deepLinkCookie = cookies.getItem('dealerSearchDeep');
      if (deepLinkParam === 'show' && (deepLinkCookie != null)) {
        $('.js-inpage-headline-back a').attr('href', '/' + tdaConfig.site.context_url + '/dealers/?deep=true')
          .parent('p').show();
      }
    }

    /* filterByTab: function(currentTab){
      if (currentTab === '#general-info') {
        dealerDetail.setupAwards();
        $('#dealer-detail-service-strip').hide();
        $('#dealer-detail-offers-strip').show();

      } else if (currentTab === '#sales-info') {
        $('#dealer-detail-service-strip').hide();
        $('#dealer-detail-offers-strip').show();

      } else if (currentTab === '#service-info') {
        $('#dealer-detail-service-strip').show();
        $('#dealer-detail-offers-strip').hide();
        if (dealerDetail.currentServiceCarousel !== '') {
          dealerDetail.currentServiceCarousel.reloadSlider();
        }

      } else if (currentTab === '#map-info') {
        $('#dealer-detail-service-strip').hide();
        $('#dealer-detail-offers-strip').hide();

      } else {
        // no tab specified
        dealerDetail.setupAwards();
        $('#dealer-detail-service-strip').hide();
        $('#dealer-detail-offers-strip').show();
      }
    } */
  }; // END dealerDetail object

  $(window).on('loaded', function () {
    window.dealerDetail = dealerDetail;
    if ($('#dealer-detail').length) {
      $('#main-wrapper-column').addClass('wrap-white'); // white BG on this page
      dealerDetail.init();
    }
  });
});

